import React from "react"
import "./CreateStory.css"
import Prompts from "../misc/Prompts";

export default class EditStory extends React.Component {
  constructor(props) {
    super(props)
    console.log(this.props.post);
    this.state = {
      avatarUrl: "",
      id: this.props.post.id,
      popup: true,
      advanced: true,
      title: this.props.post.attributes.title,
      prevTitle: this.props.post.attributes.title,
      story: this.props.post.content,
      prevText: this.props.post.content,
      numOfContributions: this.props.post.attributes.numOfContributions,
      prevNum: this.props.post.attributes.numOfContributions,
      ContCharLimit: this.props.post.attributes.charLimit,
      prevChar: this.props.post.attributes.charLimit,
      Story: this.props.post.attributes.storyPrivacy,
      prevStory: this.props.post.attributes.storyPrivacy,
      storyPrivacy: true,
      AllowedWriters: this.props.post.attributes.allowedPrivacy,
      prevAllowed: this.props.post.attributes.allowedPrivacy,
      allowed: true,
      WriterWhitelist: this.props.post.attributes.WriteList,
      prevWrite: this.props.post.attributes.WriteList,
      VotingTimeNum: this.props.post.attributes.votingQuantity,
      prevVotingTime: this.props.post.attributes.votingQuantity,
      VotingTimeMeasure: this.props.post.attributes.votingMeasure,
      prevTimeMeasure: this.props.post.attributes.votingMeasure,
      voted: true,
      sortbyHidden: true,
      sortValue: "Recent",
      genError: true,
    }
    this.generatePrompt.bind(this);
  }
  submitHandler = event => {

    //keep the form from actually submitting via HTML - we want to handle it in react
    event.preventDefault();
    //window.location.href=window.location;
    fetch(process.env.REACT_APP_API_PATH + "/posts/" + this.state.id, {
      method: "PATCH",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      },
      body: JSON.stringify({
        authorID: sessionStorage.getItem("user"),
        content: this.state.story,
        attributes: { title: this.state.title, numOfContributions: this.state.numOfContributions, charLimit: this.state.ContCharLimit, storyPrivacy: this.state.Story, allowedPrivacy: this.state.AllowedWriters, WriteList: this.state.WriterWhitelist, votingQuantity: this.state.VotingTimeNum, votingMeasure: this.state.VotingTimeMeasure }
      })
    })
      .then(
        _ => {
          this.setState({
            popup: true,
            advanced: true,
            prevTitle: "Title",
            prevText: "Text"

          })
          window.location.reload();
        }
      )
  };

  generatePrompt(type) {
    // if type is Random, just concat all of the sentence/noun prompts
    const sentenceList = Prompts.sentences[type] ? Prompts.sentences[type] : [].concat.apply([], Object.values(Prompts.sentences));
    const nounList = Prompts.nouns[type] ? Prompts.nouns[type] : [].concat.apply([], Object.values(Prompts.nouns));

    let sentence = sentenceList[Math.floor(Math.random() * sentenceList.length)];

    while (sentence.includes('[NOUN]')) {
      sentence = sentence.replace('[NOUN]', nounList[Math.floor(Math.random() * nounList.length)])
    }
    while (sentence.includes('[ADJ]')) {
      sentence = sentence.replace('[ADJ]', Prompts.adjectives[Math.floor(Math.random() * Prompts.adjectives.length)])
    }
    while (sentence.includes('[VERB]')) {
      sentence = sentence.replace('[VERB]', Prompts.verbs[Math.floor(Math.random() * Prompts.verbs.length)])
    }

    this.setState({
      story: `"${sentence}"\n\n` + this.state.story
    });
  }

  popUp() {
    this.setState({
      popup: !this.state.popup
    })
  }
  titleChangeHandler = event => {
    this.setState({
      title: event.target.value,
      prevTitle: event.target.value
    });
  };
  storyChangeHandler = event => {
    this.setState({
      story: event.target.value,
      prevStory: event.target.value
    });
  };
  ContributionsChangeHandler = event => {
    this.setState({
      numOfContributions: event.target.value
    });
  }
  ContributionCharHandler = event => {
    this.setState({
      ContCharLimit: event.target.value
    }, () => {
      if (this.state.ContCharLimit < 1) {
        this.setState({
          ContCharLimit: 1
        })
      }
    });
  }
  WriteList = event => {
    this.setState({
      WriterWhitelist: event.target.value
    });
  }
  storypri() {
    this.setState({
      storyPrivacy: !this.state.storyPrivacy
    });
  }
  publicpri() {
    this.setState({
      Story: "Public",
      storyPrivacy: !this.state.storyPrivacy
    });
  }
  privatepri() {
    this.setState({
      Story: "Private",
      storyPrivacy: !this.state.storyPrivacy
    });
  }
  allowedpri() {
    this.setState({
      allowed: !this.state.allowed
    });
  }
  allowedpublicpri() {
    this.setState({
      AllowedWriters: "Public",
      allowed: !this.state.allowed
    });
  }
  allowedprivatepri() {
    this.setState({
      AllowedWriters: "Private",
      allowed: !this.state.allowed
    });
  }
  hours() {
    if (this.state.VotingTimeNum == 1) {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Hour"
      });
    }
    else {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Hours"
      });
    }
  }
  days() {
    if (this.state.VotingTimeNum == 1) {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Day"
      });
    }
    else {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Days"
      });
    }
  }
  months() {
    if (this.state.VotingTimeNum == 1) {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Month"
      });
    }
    else {
      this.setState({
        voted: !this.state.voted,
        VotingTimeMeasure: "Months"
      });
    }
  }
  voting = event => {
    this.setState({
      VotingTimeNum: event.target.value
    }, () => {
      if (this.state.VotingTimeNum < 1) {
        this.setState({
          VotingTimeNum: 0
        })
      }
      if (this.state.VotingTimeNum > 29) {
        this.setState({
          VotingTimeNum: 29
        })
      }
      if (this.state.VotingTimeNum == 1 && this.state.VotingTimeMeasure == "Months") {
        this.setState({
          VotingTimeMeasure: "Month"
        });
      }
      else if (this.state.VotingTimeNum != 1 && this.state.VotingTimeMeasure == "Month") {
        this.setState({
          VotingTimeMeasure: "Months"
        });
      }
      else if (this.state.VotingTimeNum == 1 && this.state.VotingTimeMeasure == "Days") {
        this.setState({
          VotingTimeMeasure: "Day"
        });
      }
      else if (this.state.VotingTimeNum != 1 && this.state.VotingTimeMeasure == "Day") {
        this.setState({
          VotingTimeMeasure: "Days"
        });
      }
      else if (this.state.VotingTimeNum == 1 && this.state.VotingTimeMeasure == "Hours") {
        this.setState({
          VotingTimeMeasure: "Hour"
        });
      }
      else if (this.state.VotingTimeNum != 1 && this.state.VotingTimeMeasure == "Hour") {
        this.setState({
          VotingTimeMeasure: "Hours"
        });
      }
    });
  }
  votingMeasure() {
    this.setState({
      voted: !this.state.voted
    });
  }
  advanced() {
    this.setState({
      advanced: !this.state.advanced,
    });
  }
  advancedCancel() {
    this.setState({
      advanced: !this.state.advanced,
      numOfContributions: this.state.prevNum,
      ContCharLimit: this.state.prevChar,
      Story: this.state.prevStory,
      AllowedWriters: this.state.prevAllowed,
      WriterWhitelist: this.state.prevWrite,
      VotingTimeNum: this.state.prevVotingTime,
      VotingTimeMeasure: this.state.prevTimeMeasure
    });
  }
  advancedBack() {
    this.setState({
      advanced: !this.state.advanced,
      prevNum: this.state.numOfContributions,
      prevChar: this.state.ContCharLimit,
      prevStory: this.state.Story,
      prevAllowed: this.state.AllowedWriters,
      prevWrite: this.state.WriterWhitelist,
      prevVotingTime: this.state.VotingTimeNum,
      prevTimeMeasure: this.state.VotingTimeMeasure
    });
  }

  displaySortByFilters() {
    this.setState({
      sortbyHidden: !this.state.sortbyHidden
    })
  }

  filterRecent() {
    this.setState({
      sortValue: "Recent",
      sortbyHidden: !this.state.sortbyHidden
    })
  }

  filterOldest() {
    this.setState({
      sortValue: "Oldest",
      sortbyHidden: !this.state.sortbyHidden
    })
  }

  filterLikes() {
    this.setState({
      sortValue: "Most Likes",
      sortbyHidden: !this.state.sortbyHidden
    })
  }

  filterComments() {
    this.setState({
      sortValue: "Most Comments",
      sortbyHidden: !this.state.sortbyHidden
    })
  }

  render() {
    return (
      <div className="createStoryBox">
        <div className="StoryBar">
          <div className="EditStory" onClick={this.popUp.bind(this)}>Edit</div>
          {!this.state.advanced ? <div className="modal-container">
            <div className="AdvancedBox">
              <div className="createHeaderT">Advanced Options</div>
              <div className="promptText"><div className="maxDiv"><div>Max Contributions</div><div className="contributionsInput"><input type="number" className="contributionsField" placeholder={this.state.prevNum} onChange={this.ContributionsChangeHandler}></input></div></div>
                <div className="charDiv"><div>Contribution Character Limit</div><div className="contributionsInput"><input type="number" min="1" className="contributionChars" placeholder={this.state.prevChar} onChange={this.ContributionCharHandler}></input></div></div></div>
              <div className="promptText"><div className="privacy"><div className="privacyLabel">Story Privacy</div><div className="privacyDropdown" onClick={this.storypri.bind(this)}><div className="headText">▼ {this.state.Story}</div>
                {!this.state.storyPrivacy && <ul className="dropDownOptions">
                  <li className="centeredOptions" onClick={this.publicpri.bind(this)}>Public</li>
                  <li className="centeredOptions" onClick={this.privatepri.bind(this)}>Private</li>
                </ul>}</div></div>
                <div className="Allowed"><div className="writersLabel">Allowed Writers</div><div className="privacyDropdown2" onClick={this.allowedpri.bind(this)}><div className="headText">▼ {this.state.AllowedWriters}</div>
                  {!this.state.allowed && <ul className="dropDownOptions">
                    <li className="centeredOptions" onClick={this.allowedpublicpri.bind(this)}>Public</li>
                    <li className="centeredOptions" onClick={this.allowedprivatepri.bind(this)}>Private</li>
                  </ul>
                  }</div></div></div>
              <div className="promptText"><div className="writeli"><div className="wwList">Writer Whitelist </div><input className="WriterWhiteList" placeholder="user1;user2;user3" onChange={this.WriteList}></input></div></div>
              <div className="promptText"><div className="deadlineTime"><div className="vTime">Voting Time</div><input type="number" className="VotingNumDuration" placeholder={this.state.prevVotingTime} onChange={this.voting} min="1" max="29"></input><div className="daysDropdown" onClick={this.votingMeasure.bind(this)}><div className="headText">▼ {this.state.VotingTimeMeasure}</div>
                {!this.state.voted && <ul className="votingDownOptions">
                  <li className="centeredOptions" onClick={this.hours.bind(this)}>Hours</li>
                  <li className="centeredOptions" onClick={this.days.bind(this)}>Days</li>
                  <li className="centeredOptions" onClick={this.months.bind(this)}>Months</li>
                </ul>
                }</div></div></div>
              <div className="footerAdvStory">
                <button className="BackButton" onClick={this.advancedBack.bind(this)}>Back</button>
                <button className="PostAdvButton" onClick={this.submitHandler}>Post</button>
                <button className="CancelButton" onClick={this.advancedCancel.bind(this)}>Cancel</button></div>
            </div></div>
            : !this.state.popup ? <div className="modal-container">
              <div className="StoryBox">
                <div className="createHeaderT">Edit Your Story</div>
                <div className="titleInput"><input className="titleField" value={this.state.title} placeholder={this.state.prevTitle} onChange={this.titleChangeHandler}></input></div>
                <textarea className="storyInput" value={this.state.story} placeholder={this.state.prevText} onChange={this.storyChangeHandler} />
                <div className="generatePrompt">
                  <div className="promptText">Not sure what to write about? Generate a prompt here!</div>
                  <div className="promptButtons">
                    <button onClick={_ => this.generatePrompt('Fantasy')} className="promptButtonF">Fantasy</button>
                    <button onClick={_ => this.generatePrompt('Adventure')} className="promptButton">Adventure</button>
                    <button onClick={_ => this.generatePrompt('Educational')} className="promptButton">Educational</button>
                    <button onClick={_ => this.generatePrompt('Random')} className="promptButton">Random</button>
                  </div>
                </div>
                <div className="footerStory">
                  <div className="advancedText" onClick={this.advanced.bind(this)}>Advanced Options...</div>
                  <button className="PostButton" onClick={this.submitHandler}>Post</button>
                  <button className="CancelButton" onClick={this.popUp.bind(this)}>Cancel</button>
                </div></div></div> : ""}
        </div>
      </div>
    )
  }
}